import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SalesOrderHeaderExtraItem } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderExtraItemService extends TmsWebBaseEditCreateService<
  SalesOrderHeaderExtraItem,
  SalesOrderHeaderExtraItem
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderExtraItem', $localize`Sales Order Extra Item`);
  }

  getForSalesOrderHeader(id: string): Observable<SalesOrderHeaderExtraItem[]> {
    return this.httpService.get<SalesOrderHeaderExtraItem[]>(`${this.apiUrl}/SalesOrderHeader?id=${id}`);
  }
}
